'use client';

import {
	HStack,
	IconButton,
	Stack,
	Text,
} from '@chakra-ui/react';

import { LuX } from 'react-icons/lu';
import { NextImageWithSkeleton } from '@packages/chakra-v3';
import { currencyFormatter } from '@/utils/currency';

type Attribute = {
	label: string;
	value: string;
};

type CartItem =  {
	name:       string;
	price:      number;
	attributes: Attribute[];
};

type CartItemCardProps = {
	cartItem:           CartItem;
	onClickRemoveIcon?: () => void;
};

const CartItemCard = ({ cartItem, onClickRemoveIcon }: CartItemCardProps) => {
	return (
		<HStack
			alignContent={'center'}
			gap={16}
			layerStyle={'black'}
			p={4}
		>
			<NextImageWithSkeleton
				alt={cartItem.name}
				aspectRatio={'1/1'}
				src={'https://via.placeholder.com/150'}
				width={'200px'}
			/>
			<Stack gap={2} w={'100%'}>
				<HStack alignItems={'flex-start'} justifyContent={'space-between'} >
					<Stack gap={2}>
						<Text textStyle={'s5'} textTransform={'uppercase'}>
							{cartItem.name}
						</Text>
						<Text textStyle={'p3'}>{currencyFormatter.format(cartItem.price)}</Text>
					</Stack>
					{onClickRemoveIcon && (
						<IconButton
							aria-label={'Remove item'}
							size={'xs'}
							onClick={onClickRemoveIcon}
						>
							<LuX />
						</IconButton>
					)}
				</HStack>
				<Stack gap={2}>
					{cartItem.attributes.map(({ label, value }) => (
						<HStack
							key={label}
							gap={4}
						>
							<Text fontWeight={'bold'} textStyle={'p3'}>{label}</Text>
							<Text textStyle={'p3'}>{value}</Text>
						</HStack>
					))}
				</Stack>
				<HStack gap={4}>
					<Text fontWeight={'bold'} textStyle={'p3'}>Quantity:</Text>
					<Text textStyle={'p3'}>1</Text>
				</HStack>
			</Stack>
		</HStack>
	);
};

export default CartItemCard;